<template>
    <div>
        <router-view />
    </div>
</template>

<script>
export default {
    name: 'App'
}
</script>

<style lang="less" >
@import "~@/assets/styles/reset.less";
@import "~@/assets/styles/icon.less";
</style>
